import React, { useContext, useState } from "react";
import SignInForm from './SignInForm';
import { loginPost, getVerify } from '../../api';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import classes from './index.module.scss';
import { Container, Row, Col } from "react-bootstrap";
import { HashLink } from 'react-router-hash-link';
import { somethingWentWrongNotice, successNotice, wrongCredentialsNotice } from '../UI/Notifications';
import WhatsNewBanner from "components/UpdateWhatsNewMessage/WhatsNewBanner";

const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();
  const querystring = require('querystring');

  const login = (userData) => {
    setIsLoggedIn(true);
    setUser(userData);
    history.push("/dashboard");
  }

  const verification = (responseData) => {
    setLoading(true);
    const params = {
      user_id: responseData.user_id,
      hash_data: responseData.hash_data,
      link: `${window.origin}/user-verification`
    }

    getVerify(params)
      .then(() => {
        const queryString = querystring.stringify(params);
        setLoading(false);
        history.push(`/send-again?${queryString}`);
      })
      .catch(() => {
        somethingWentWrongNotice("Sign In");
        setLoading(false);
      });
  }

  const loginPostRequest = (dataObj) => {
    setLoading(true);
    loginPost(dataObj)
    .then(response => {
      setLoading(false);
      login(response.data);
      successNotice("Sign In");
    })
    .catch(error => {
      if (error.response.status === 404) {
        wrongCredentialsNotice();
        setLoading(false);
      }
      if (error.response.status === 401) verification(error.response.data);
      if (![401, 404].includes(error.response.status)) {
        somethingWentWrongNotice("Sign In");
        setLoading(false);
      }
    })
  }

  const onSubmit = (data, e) => {
    setLoading(true)
    e.preventDefault();
    e.target.reset();
    
    loginPostRequest(data);
  };

  return (
    <Container>
      <Row>
        <Col lg={{span: 6, offset: 3}}>
          <div className={classes.Sign_In_Form_Wrap}>
            <h2 className="text-center">Sign In</h2>
            <h6 className="text-center">
              Don’t have an account?
              <HashLink smooth to="/#basic-info">Register</HashLink>
            </h6>
            <WhatsNewBanner styleClass="Whats_New" />
            <SignInForm
              onSubmit={onSubmit}
              loading={loading}
            />
          </div>
        </Col>
      </Row>
    </Container>
   
  );
}

export default SignIn;
